import { FleekError } from './FleekError';

type Application = {
  id?: string;
  name?: string;
};

type ApplicationAlreadyExistsErrorOptions = {
  application: Application;
};

export class ApplicationAlreadyExistsError extends FleekError<ApplicationAlreadyExistsErrorOptions> {
  public name = 'ApplicationAlreadyExistsError';

  toString = () => `Application ${this.data.application.name} already exists.`;
}
